import { computed } from 'vue';
import { useAccountsStore } from '../accounts/accounts-store';

const getAccountNameFromId = (accountId) => {
  const store = useAccountsStore();
  const accounts = computed(() => store.state.accounts);
  if (!accountId) return '-';
  const account = accounts.value.find(a => a.id == accountId);
  return account ? account.name : '-';
}

export default getAccountNameFromId;
